import type * as React from "react";
import { type ReactNode } from "react";
import { Accordion, AccordionDetails, AccordionSummary, styled } from "~/common/mui";
import { useTranslation } from "react-i18next";

interface FilterGroupItemProps {
  className?: string;
  initiallyExpanded?: boolean;
  title: string;
  "data-test-id"?: string;
  children?: ReactNode;
  hidden?: boolean;
}

const FilterGroupItem: React.FC<FilterGroupItemProps> = (props) => {
  const testId = props["data-test-id"] ? `filter-category-${props["data-test-id"]}` : undefined;
  const baseId = props["data-test-id"] ? `filter-${props["data-test-id"]}` : undefined;
  const summaryId = baseId ? `${baseId}-summary` : undefined;
  const detailsId = baseId ? `${baseId}-details` : undefined;
  const { t } = useTranslation();
  return (
    <StyledAccordion defaultExpanded={props.initiallyExpanded} hidden={props.hidden}>
      <AccordionSummary id={summaryId} aria-controls={detailsId} data-test-id={testId} sx={{ userSelect: "text" }}>
        {t(props.title)}
      </AccordionSummary>
      <AccordionDetails id={detailsId} aria-labelledby={summaryId} role="region" className={props.className}>
        {props.children}
      </AccordionDetails>
    </StyledAccordion>
  );
};

export default FilterGroupItem;

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  borderRadius: "0",
  backgroundColor: theme.palette.surface.bright,
  "&::before": {
    backgroundColor: "transparent",
    borderTop: `1px solid ${theme.palette.divider} !Important`,
    top: 0,
    height: "1px !Important",
  },

  "&::after": {
    height: "1px !Important",
    borderBottom: `1px solid ${theme.palette.divider} !Important`,
  },
}));
